/* eslint-disable react/prop-types */
import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  InputAdornment,
  SvgIcon,
} from "@material-ui/core";
import { Search as SearchIcon } from "react-feather";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { Link as RouterLink, useNavigate, useLocation } from "react-router-dom";
import DatePicker from "@mui/lab/DatePicker";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

const CustomerListToolbar = ({
  clickToSearch,
  datesearch,
  handleChangeselect,
  selectvalue,
  // selectvalues,
  // handleChangeselected,
  fromdate,
  todate,
  handleSearchText,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [firstdate, setFirstDate] = useState("");
  const [seconddate, setSecondDate] = useState("");
  const [searchtext, setSearchtext] = useState("");
  const [bookedFilter, setBookedFilter] = useState("");
  const [deliveryType, setDeliveryType] = useState(1);
  // const [value, setValue] = useState(new Date());
  // const [age, setAge] = useState('');

  // const { clickToSearch, datesearch, handleChangeselect, selectvalue } = props;

  const handleSearchInvNo = (inv) => {
    setSearchtext(inv);
    handleSearchText(inv);
  };

  const handleDeliveryType = (id) => {
    setDeliveryType(id);
    const navigateTo = id === 1 ? "/app/customers" : "/app/stocktransfer";
    if (navigateTo) {
      navigate(navigateTo, { replace: true, state: { deliveryType: id } });
    } else {
      return 1;
    }
  };

  useEffect(() => {
    const deliveryType = location.state?.deliveryType;
    console.log("************************", deliveryType)

    setDeliveryType(deliveryType == undefined ? 1 : deliveryType);
  }, []);

  useEffect(() => {
    setBookedFilter(selectvalue);
    setFirstDate(fromdate);
    setSecondDate(todate);
  }, [fromdate, todate]);
  return (
    // <Box {...props}>
    <Box>
      <Box sx={{ mt: 0 }}>
        <Card>
          <CardContent>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={3}>
                <Grid item xs={3} style={{ display: "flex" }}>
                  <h2>Stock Transfer List</h2>
                </Grid>
              </Grid>
            </Box>
            <Box sx={{ flexGrow: 1 }}>
              <Grid container spacing={3}>
                <Grid item xs={3} style={{ display: "flex" }}>
                  <TextField
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SvgIcon fontSize="small" color="action">
                            <SearchIcon />
                          </SvgIcon>
                        </InputAdornment>
                      ),
                    }}
                    sx={{ width: "50ch" }}
                    placeholder="Search "
                    onChange={(e) => handleSearchInvNo(e.target.value)}
                    onKeyPress={(e) => clickToSearch(e, "1")}
                  />
                  <Button
                    variant="contained"
                    onClick={() => clickToSearch(searchtext, "2")}
                  >
                    Search
                  </Button>
                </Grid>
                {/* <Grid item xs={2} style={{ display: 'grid' }}>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={selectvalues}
                    onChange={handleChangeselected}
                  >
                    <MenuItem value={0}>Invoice Status-All</MenuItem>
                    <MenuItem value={1}>Initiated</MenuItem>
                    <MenuItem value={5}>Ready For Dispatch</MenuItem>
                  </Select>
                </Grid> */}
                <Grid item xs={2} style={{ display: "grid" }}>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={bookedFilter}
                    onChange={(e) => {
                      setBookedFilter(e.target.value);
                      datesearch(firstdate, seconddate, e.target.value);
                    }}
                  >
                    <MenuItem value={2}>Booked Status-All</MenuItem>
                    <MenuItem value={0}>Pending</MenuItem>
                    <MenuItem value={1}>Booked</MenuItem>
                  </Select>
                </Grid>
                <Grid item xs={2}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="Delivery From Date"
                      value={firstdate}
                      format="yyyy-MM-dd HH:mm:ss"
                      onChange={(newValue) => {
                        datesearch(newValue, seconddate, bookedFilter);
                        setFirstDate(newValue);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid item xs={2}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      label="Delivery To Date"
                      value={seconddate}
                      onChange={(newValue) => {
                        datesearch(firstdate, newValue, bookedFilter);
                        setSecondDate(newValue);
                      }}
                      renderInput={(params) => <TextField {...params} />}
                      format="yyyy-MM-dd HH:mm:ss"
                    />
                  </LocalizationProvider>
                </Grid>

                <Grid item xs={2} style={{ display: "grid" }}>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={deliveryType}
                    onChange={(e) => {
                      handleDeliveryType(e.target.value);
                    }}
                  >
                    <MenuItem value={1}>Invoice</MenuItem>
                    <MenuItem value={2}>Stock Transfer</MenuItem>
                  </Select>
                </Grid>

                {/* <Grid item xs={1}>
                  <Button
                    color="primary"
                    onClick={() => {
                      datesearch(firstdate, seconddate);
                    }}
                  >
                    <SvgIcon fontSize="large" color="action">
                      <SearchIcon />
                    </SvgIcon>
                  </Button>
                </Grid> */}
              </Grid>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default CustomerListToolbar;
